<div class="header-language">
  <button (click)="setLanguage('en')" [ngClass]="{ active: languageCode === 'en' }">ENG</button>
  /
  <button (click)="setLanguage('es')" [ngClass]="{ active: languageCode === 'es' }">ESP</button>
</div>
